export const MICRODOSE_MIN_BMI_THRESHOLD = 22;

export const MICRODOSE_MAX_BMI_THRESHOLD = 27;

export const MICRODOSE_WEIGHT_LOSS_AFTER_THREE_MONTHS = 10;
